import { render } from "./router_back.vue?vue&type=template&id=0c380cf3&scoped=true"
import script from "./router_back.vue?vue&type=script&lang=js"
export * from "./router_back.vue?vue&type=script&lang=js"

import "./router_back.vue?vue&type=style&index=0&id=0c380cf3&lang=scss&scoped=true"

import exportComponent from "D:\\Abdulahad\\Front end\\at_rp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c380cf3"]])

export default __exports__